import { EnvironmentType, MerchantType } from "@/enums/enums";
import { i18n } from "@/i18n";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";

const peakDomain = process.env.VUE_APP_PeakDomain;
const secretKeyAESIndexedDbCash = "peakIndexedDbCash";

function IsSetCookiesInDomain() {
  let isSetDomain = false;

  if (peakDomain) {
    const domainList = location.hostname.split(".");
    const start = -(domainList.length - 1);
    const locationDomain = `.${domainList.slice(start).join(".")}`;

    if (locationDomain == peakDomain) {
      isSetDomain = true;
    }
  }

  return isSetDomain;
}

export function NewObject(obj: any) {
  if (obj) {
    return JSON.parse(JSON.stringify(obj));
  } else {
    return obj;
  }
}
export function CheckIsDevelop(): boolean {
  const typeEnv: number = JSON.parse(process.env.VUE_APP_TYPE_ENV ?? "-1");

  return [EnvironmentType.Dev, EnvironmentType.SIT].includes(typeEnv);
}
export function GetMerchantNameWihtMerchantType(merchantType: number, merchantName: string) {
  let merchantFullName: any = "";
  switch (merchantType) {
    case MerchantType.LimitedLiabilityPartnership:
      merchantFullName = i18n.t("MerchantType.LimitedLiabilityPartnership", { name: merchantName });
      break;
    case MerchantType.Association:
      merchantFullName = i18n.t("MerchantType.Association", { name: merchantName });
      break;
    case MerchantType.JointVenture:
      merchantFullName = i18n.t("MerchantType.JointVenture", { name: merchantName });
      break;
    case MerchantType.CompanyLimited:
      merchantFullName = i18n.t("MerchantType.CompanyLimited", { name: merchantName });
      break;
    case MerchantType.PublicCompanyLimited:
      merchantFullName = i18n.t("MerchantType.PublicCompanyLimited", { name: merchantName });
      break;
    case MerchantType.Shop:
      merchantFullName = i18n.t("MerchantType.Shop", { name: merchantName });
      break;
    case MerchantType.OrdinaryPerson:
      merchantFullName = i18n.t("MerchantType.OrdinaryPerson", { name: merchantName });
      break;
    case MerchantType.BodyOfPersons:
      merchantFullName = i18n.t("MerchantType.BodyOfPersons", { name: merchantName });
      break;
    case MerchantType.Others:
      merchantFullName = i18n.t("MerchantType.Others", { name: merchantName });
      break;
    case MerchantType.OrdinaryPartnership:
      merchantFullName = i18n.t("MerchantType.OrdinaryPartnership", { name: merchantName });
      break;
    case MerchantType.Foundation:
      merchantFullName = i18n.t("MerchantType.Foundation", { name: merchantName });
      break;
  }
  return merchantFullName;
}
export function CheckTextTooLong(numberCharacter: number, limitNumberCharacter: number) {
  return numberCharacter > limitNumberCharacter;
}
export function DecodeJwtResponse(credential: any) {
  return JSON.parse(atob(credential.split(".")[1]).toString());
}

function DetectTabClosing(e: any) {
  const confirmationMessage = "";

  (e || window.event).returnValue = confirmationMessage;
  return confirmationMessage;
}

export function AddDetectTabClosing() {
  window.addEventListener("beforeunload", DetectTabClosing);
}
export function RemoveDetectTabClosing() {
  window.removeEventListener("beforeunload", DetectTabClosing);
}

export function UnsetOverflowModalBox(unsetOverflow: boolean) {
  const elementIdList = document.querySelectorAll("[id='modalBox']");

  if (elementIdList.length > 0) {
    elementIdList.forEach((elementId) => {
      let element = null;
      element = elementId.getElementsByClassName("modalBox")[0];
      if (element) {
        if (unsetOverflow) {
          element.classList.add("unsetOverflow");
          element.classList.add("isCanNotRemoveCalss");
          setTimeout(() => {
            const elementModalBox = elementId.getElementsByClassName("modalBox")[0];
            elementModalBox.classList.remove("isCanNotRemoveCalss");
          }, 500);
        } else {
          if (!element.classList.contains("isCanNotRemoveCalss")) {
            element.classList.remove("unsetOverflow");
          }
        }
      }
    });
  }
}

export function FixUrlDoubleSlashes(url: string) {
  return url.replace(/([^:])\/\//g, "$1/");
}

export const CreateMetaTagProperty = (property: string, content: string) => {
  const meta = document.createElement("meta");
  meta.setAttribute("property", property);
  meta.setAttribute("content", content);
  document.getElementsByTagName("head")[0].appendChild(meta);
};

export const CreateMetaTagName = (name: string, content: string) => {
  const meta = document.createElement("meta");
  meta.setAttribute("name", name);
  meta.setAttribute("content", content);
  document.getElementsByTagName("head")[0].appendChild(meta);
};

export const RemoveMetaTagProperty = (property: string) => {
  const existingMeta = document.querySelector(`[property='${property}']`);
  if (existingMeta) {
    existingMeta.remove();
  }
};

export const RemoveMetaTagName = (name: string) => {
  const existingMeta = document.querySelector(`[name='${name}']`);
  if (existingMeta) {
    existingMeta.remove();
  }
};

export function GetCommentTextForDisplay(commentText: string, userIdListForMap: Map<number, any>) {
  let commentTextForDisplay = commentText;
  if (commentText) {
    const userIds: any = commentText.match(/\[\[userId\d+\]\]/g);
    if (userIds && userIds.length > 0) {
      for (const userId of userIds) {
        const extractedUserId = Number(userId.match(/\d+/)[0]);
        const selectedUser = userIdListForMap.get(extractedUserId);
        if (selectedUser) {
          const userNameBox = `<span style="color:#3297ff;font-family: 'Maibork-bold';">@${selectedUser.displayName}</span>`;
          commentTextForDisplay = commentTextForDisplay.replaceAll(userId, userNameBox);
        }
      }
    }
  }
  return commentTextForDisplay;
}

export function GetCookie(cookieName: string) {
  return Cookies.get(cookieName);
}

export function SetCookie(cookieName: string, value: any, expireDays: number) {
  if (IsSetCookiesInDomain()) {
    Cookies.set(cookieName, value, { expires: expireDays, domain: peakDomain });
  } else {
    Cookies.set(cookieName, value, { expires: expireDays });
  }
}

export function DeleteCookie(cookieName: string) {
  if (IsSetCookiesInDomain()) {
    Cookies.remove(cookieName, { domain: peakDomain });
  } else {
    Cookies.remove(cookieName);
  }
}

export function GetUserIdFromCommentText(commentText: string) {
  if (commentText) {
    const userIds = commentText.match(/\[\[userId\d+\]\]/g);
    if (userIds) {
      const extractedUserIds = userIds.map((userId: any) => Number(userId.match(/\d+/)[0]));
      return extractedUserIds;
    }
  }
  return [];
}

export const EncryptionIndexedDbCash = (cashString: string): string => {
  if (cashString) {
    const encrypted = CryptoJS.AES.encrypt(cashString.toString(), secretKeyAESIndexedDbCash);
    return encrypted.toString();
  }
  return "";
};

export const DecryptionIndexedDbCash = (encryptCashString: string): string => {
  if (encryptCashString) {
    const originalMessage = CryptoJS.AES.decrypt(encryptCashString, secretKeyAESIndexedDbCash);
    return originalMessage.toString(CryptoJS.enc.Utf8);
  }
  return "";
};

export const IsEnabledEWF = (): boolean => {
  return CheckIsDevelop();
};
